import { render, staticRenderFns } from "./addUserView.vue?vue&type=template&id=1a120004&"
import script from "./addUserView.vue?vue&type=script&lang=js&"
export * from "./addUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports